import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const Ionic = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 24 24" {...props}>
    <path
      clipRule="evenodd"
      d="M18.91 7.966a2.5 2.5 0 0 1-2.877-2.877 8 8 0 1 0 2.877 2.877Zm-1.785-4.554a2.5 2.5 0 0 1 3.463 3.463A9.954 9.954 0 0 1 22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2c1.873 0 3.627.515 5.125 1.412ZM12 16a4 4 0 1 1 0-8 4 4 0 0 1 0 8Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </Icon>
));

export default Ionic;
